import { render, staticRenderFns } from "./PickUpServiceReport.vue?vue&type=template&id=28680f9a&scoped=true&"
import script from "./PickUpServiceReport.vue?vue&type=script&lang=js&"
export * from "./PickUpServiceReport.vue?vue&type=script&lang=js&"
import style0 from "./PickUpServiceReport.vue?vue&type=style&index=0&id=28680f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28680f9a",
  null
  
)

export default component.exports